export const heroSlides = [
  {
    id: 1,
    title: "流浪地球3",
    description: "中国科幻巨制续作，人类命运再次面临终极抉择",
    category: "电影",
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinematic%20scene%20with%20massive%20space%20station%20and%20Earth%20from%20orbit%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20cinematic%20composition%2C%20orange%20and%20teal%20color%20grade%2C%20warm%20atmospheric%20glow%2C%20film%20poster%20quality%2C%20dark%20space%20background%20with%20stars&width=1600&height=700&seq=hero-slide-01&orientation=landscape",
  },
  {
    id: 2,
    title: "繁花",
    description: "王家卫首部电视剧，上海滩商海沉浮的时代画卷",
    category: "电视剧",
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Vintage%20Shanghai%20night%20scene%20with%20neon%20lights%20and%20art%20deco%20buildings%2C%20warm%20golden%20tones%2C%20elegant%20cinematic%20mood%2C%201990s%20Chinese%20nostalgia%2C%20rain-slicked%20streets%2C%20romantic%20atmosphere%2C%20film%20noir%20inspired%2C%20warm%20amber%20lighting&width=1600&height=700&seq=hero-slide-02&orientation=landscape",
  },
  {
    id: 3,
    title: "一年一度喜剧大赛",
    description: "爆笑喜剧竞技综艺，各路喜剧人齐聚一堂",
    category: "综艺",
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Vibrant%20comedy%20stage%20show%20with%20warm%20spotlights%20and%20colorful%20set%20design%2C%20energetic%20performance%20atmosphere%2C%20theater%20stage%20with%20red%20curtains%2C%20joyful%20celebration%20mood%2C%20bright%20warm%20lighting%2C%20entertainment%20show%20production%20quality&width=1600&height=700&seq=hero-slide-03&orientation=landscape",
  },
];

export const featuredContent = [
  {
    id: 1,
    title: "流浪地球3",
    category: "电影",
    subCategory: "科幻",
    rating: 9.2,
    views: 12800000,
    year: 2026,
    description: "太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的宇宙旅程，人类命运再次面临终极抉择...",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20with%20futuristic%20space%20theme%2C%20dramatic%20lighting%2C%20sci-fi%20aesthetic%2C%20epic%20scale%2C%20warm%20orange%20and%20deep%20blue%20contrast%2C%20clean%20background%20with%20stars%2C%20minimalist%20poster%20design&width=400&height=560&seq=featured-01&orientation=portrait",
    badge: "热播中",
  },
  {
    id: 2,
    title: "繁花",
    category: "电视剧",
    subCategory: "都市",
    rating: 9.4,
    views: 25600000,
    year: 2026,
    description: "九十年代的上海，阿宝在时代的浪潮中从平凡走向辉煌，上演了一出跌宕起伏的商海传奇与情感纠葛...",
    image: "https://readdy.ai/api/search-image?query=Elegant%20Chinese%20drama%20poster%20with%20vintage%20Shanghai%20aesthetic%2C%20warm%20golden%20and%20amber%20tones%2C%20romantic%20atmosphere%2C%201990s%20nostalgia%2C%20art%20deco%20elements%2C%20cinematic%20portrait%20style%2C%20clean%20minimal%20composition&width=400&height=560&seq=featured-02&orientation=portrait",
    badge: "爆款",
  },
  {
    id: 3,
    title: "一年一度喜剧大赛",
    category: "综艺",
    subCategory: "喜剧",
    rating: 9.0,
    views: 18900000,
    year: 2026,
    description: "各路喜剧人齐聚一堂，用最爆笑的表演征服观众，每一期都是笑到停不下来的欢乐盛宴...",
    image: "https://readdy.ai/api/search-image?query=Colorful%20comedy%20show%20poster%20with%20bright%20warm%20stage%20lighting%2C%20joyful%20and%20playful%20design%2C%20entertainment%20variety%20show%20style%2C%20vibrant%20red%20and%20gold%20accents%2C%20clean%20background%2C%20energetic%20composition&width=400&height=560&seq=featured-03&orientation=portrait",
    badge: "热播中",
  },
  {
    id: 4,
    title: "封神第二部",
    category: "电影",
    subCategory: "奇幻",
    rating: 8.8,
    views: 21300000,
    year: 2026,
    description: "殷商末年，一场人、仙、妖之间旷日持久的神话战争拉开帷幕，封神榜的传说由此展开...",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20fantasy%20movie%20poster%2C%20dramatic%20ancient%20Chinese%20warrior%20theme%2C%20warm%20golden%20and%20crimson%20tonal%20palette%2C%20mythical%20creatures%20silhouettes%2C%20cinematic%20epic%20scale%2C%20clean%20simple%20background&width=400&height=560&seq=featured-04&orientation=portrait",
    badge: "新上线",
  },
  {
    id: 5,
    title: "狂飙",
    category: "电视剧",
    subCategory: "犯罪",
    rating: 9.1,
    views: 34200000,
    year: 2025,
    description: "一部横跨二十年的扫黑除恶群像剧，展现时代变迁下人性的复杂与正义的坚持...",
    image: "https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20poster%2C%20dark%20and%20moody%20atmosphere%2C%20urban%20noir%20aesthetic%2C%20dramatic%20lighting%20with%20warm%20accents%2C%20suspenseful%20tone%2C%20minimalist%20poster%20design%2C%20clean%20dark%20background&width=400&height=560&seq=featured-05&orientation=portrait",
    badge: "经典",
  },
  {
    id: 6,
    title: "向往的生活",
    category: "综艺",
    subCategory: "真人秀",
    rating: 8.5,
    views: 15600000,
    year: 2026,
    description: "远离城市喧嚣，回归田园生活。明星嘉宾们在乡村小屋中体验最质朴的生活乐趣...",
    image: "https://readdy.ai/api/search-image?query=Warm%20pastoral%20Chinese%20variety%20show%20poster%2C%20cozy%20countryside%20cottage%20with%20golden%20sunset%20light%2C%20peaceful%20rural%20atmosphere%2C%20natural%20green%20tones%2C%20warm%20and%20inviting%20design%2C%20clean%20simple%20composition&width=400&height=560&seq=featured-06&orientation=portrait",
    badge: "热播中",
  },
];

export const categories = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-movie-line",
    description: "最新院线大片，经典永不过时",
    count: 1280,
  },
  {
    slug: "drama",
    name: "电视剧",
    icon: "ri-tv-line",
    description: "热播好剧追不停",
    count: 960,
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-emotion-laugh-line",
    description: "欢乐解压，笑点不断",
    count: 540,
  },
  {
    slug: "anime",
    name: "动漫",
    icon: "ri-rocket-line",
    description: "二次元的世界，无限精彩",
    count: 720,
  },
  {
    slug: "documentary",
    name: "纪录片",
    icon: "ri-earth-line",
    description: "探索世界，发现真相",
    count: 380,
  },
  {
    slug: "kids",
    name: "少儿",
    icon: "ri-star-smile-line",
    description: "寓教于乐，快乐成长",
    count: 450,
  },
];

export const latestContent = [
  {
    id: 1,
    title: "长津湖之水门桥",
    category: "电影",
    subCategory: "战争",
    rating: 8.9,
    updateDate: "2026-07-30",
    image: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20war%20film%20scene%20with%20soldiers%20in%20snow%20battle%2C%20dramatic%20cinematic%20lighting%2C%20cold%20blue%20and%20warm%20fire%20contrast%2C%20heroic%20atmosphere%2C%20cinematic%20composition%2C%20clean%20minimal%20background&width=360&height=240&seq=latest-01&orientation=landscape",
    tag: "新上线",
  },
  {
    id: 2,
    title: "三体",
    category: "电视剧",
    subCategory: "科幻",
    rating: 8.7,
    updateDate: "2026-07-29",
    image: "https://readdy.ai/api/search-image?query=Mysterious%20sci-fi%20atmosphere%20with%20cosmic%20theme%2C%20three%20suns%20in%20alien%20sky%2C%20philosophical%20and%20grand%20scale%2C%20deep%20space%20background%2C%20warm%20and%20cold%20color%20contrast%2C%20cinematic%20quality&width=360&height=240&seq=latest-02&orientation=landscape",
    tag: "更新至12集",
  },
  {
    id: 3,
    title: "奔跑吧·生态篇",
    category: "综艺",
    subCategory: "户外竞技",
    rating: 8.3,
    updateDate: "2026-07-28",
    image: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20variety%20show%20scene%2C%20bright%20sunny%20nature%20landscape%2C%20energetic%20group%20running%2C%20vibrant%20green%20and%20warm%20sunlight%2C%20cheerful%20atmosphere%2C%20clean%20natural%20background&width=360&height=240&seq=latest-03&orientation=landscape",
    tag: "更新至8期",
  },
  {
    id: 4,
    title: "深海",
    category: "动漫",
    subCategory: "奇幻",
    rating: 9.0,
    updateDate: "2026-07-27",
    image: "https://readdy.ai/api/search-image?query=Dreamlike%20underwater%20animated%20scene%20with%20colorful%20marine%20life%2C%20magical%20deep%20sea%20atmosphere%2C%20particle%20effects%20like%20flowing%20ink%2C%20vibrant%20blues%20and%20warm%20accents%2C%20Chinese%20animation%20art%20style&width=360&height=240&seq=latest-04&orientation=landscape",
    tag: "新上线",
  },
  {
    id: 5,
    title: "航拍中国·第四季",
    category: "纪录片",
    subCategory: "自然",
    rating: 9.5,
    updateDate: "2026-07-26",
    image: "https://readdy.ai/api/search-image?query=Breathtaking%20aerial%20landscape%20photography%20of%20Chinese%20mountains%20and%20rivers%2C%20golden%20sunrise%20light%2C%20majestic%20natural%20scenery%2C%20documentary%20cinematography%20quality%2C%20warm%20earthy%20tones%2C%20clean%20vast%20sky&width=360&height=240&seq=latest-05&orientation=landscape",
    tag: "更新至6集",
  },
  {
    id: 6,
    title: "熊出没·逆转时空",
    category: "少儿",
    subCategory: "动画",
    rating: 8.2,
    updateDate: "2026-07-25",
    image: "https://readdy.ai/api/search-image?query=Colorful%20Chinese%20animated%20film%20scene%20with%20cute%20bear%20characters%20in%20forest%2C%20bright%20cheerful%20colors%2C%20family-friendly%20cartoon%20style%2C%20warm%20sunlight%20through%20trees%2C%20playful%20atmosphere&width=360&height=240&seq=latest-06&orientation=landscape",
    tag: "新上线",
  },
];

export const faqItems = [
  {
    id: 1,
    question: "西瓜视频是否需要付费？",
    answer: "不需要！西瓜视频所有内容完全免费在线观看，无需任何付费会员。我们致力于为观众提供优质的免费观影体验，让每个人都能轻松享受影视娱乐。",
  },
  {
    id: 2,
    question: "是否需要下载APP才能观看？",
    answer: "不需要下载任何软件。西瓜视频支持网页端和手机端直接播放，打开浏览器即可观看，超清画质流畅不卡顿，方便快捷。",
  },
  {
    id: 3,
    question: "视频画质如何？会卡顿吗？",
    answer: "西瓜视频全部内容提供超清画质，最高支持4K分辨率。我们的CDN加速技术确保播放流畅不卡顿，即使在移动网络环境下也能获得良好的观看体验。",
  },
  {
    id: 4,
    question: "内容多久更新一次？",
    answer: "我们每天都会更新最新内容，包括最新上映的电影、热播电视剧的最新集数以及各类综艺节目。关注我们，不错过任何精彩内容。",
  },
  {
    id: 5,
    question: "可以在电视上观看吗？",
    answer: "可以的！西瓜视频支持投屏功能，您可以将手机或电脑上的内容投射到智能电视上观看，享受大屏观影体验。",
  },
  {
    id: 6,
    question: "支持哪些设备观看？",
    answer: "西瓜视频支持所有主流设备：电脑（Windows/Mac）、手机（iOS/Android）、平板电脑以及智能电视。随时随地，想看看就看。",
  },
];

export const stats = [
  { label: "影视内容", value: "12,000+" },
  { label: "每日更新", value: "200+" },
  { label: "月活用户", value: "5000万+" },
  { label: "用户评分", value: "4.9" },
];